import React, { useState, useEffect } from "react"

export default function FlashMessage({ flashMessage, flashMessageMode }) {
  const [showFlash, setShowFlash] = useState(false)
  const [fadeOut, setFadeOut] = useState(false)

  useEffect( () => {
    if (flashMessage) {
      setShowFlash(true)
      setTimeout(() => {
        setFadeOut(true)
      }, 3000)
      setTimeout(() => {
        setShowFlash(false)
      }, 4000)
    }
  }, [flashMessage])

  const modesMap = {
    'success': 'fa-check',
    'error': 'fa-hexagon-exclamation',
    'notice': 'fa-flag'
  }
  const flashIcon = <i className={`fa-regular ${modesMap[flashMessageMode || 'success']}`}></i>

  return (
    <>
      { showFlash &&
        <div className={`flash-container ${flashMessageMode} ${fadeOut ? 'animated fadeOutRight ' : 'animated fadeInRight'}`}>
          <div className='flex-box items-center content-center'>
            { flashIcon }
            <div style={{ marginLeft: 20 }}>{ flashMessage }</div>
          </div>
        </div>
      }
    </>
  )
}
